import { render, staticRenderFns } from "./BusinessAuth.vue?vue&type=template&id=3576b63e&scoped=true"
import script from "./BusinessAuth.vue?vue&type=script&lang=js"
export * from "./BusinessAuth.vue?vue&type=script&lang=js"
import style0 from "./BusinessAuth.vue?vue&type=style&index=0&id=3576b63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576b63e",
  null
  
)

export default component.exports